module.exports = __webpack_public_path__ + "img/vol05_character_img02.90d37145.png";